import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaCheckCircle, FaTimes } from 'react-icons/fa';
import sampleData from '../../data/sampleData';
import { toast } from 'react-toastify';
import './Disputes.css';

const DisputeDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispute = sampleData.disputes.find(d => d.id === parseInt(id));
  const [resolution, setResolution] = useState('');

  if (!dispute) {
    return (
      <div className="empty-state">
        <h3>Dispute not found</h3>
        <button onClick={() => navigate('/disputes')} className="btn btn-primary">
          Back to Disputes
        </button>
      </div>
    );
  }

  const handleResolve = () => {
    if (!resolution.trim()) {
      toast.warning('Please provide a resolution');
      return;
    }
    toast.success('Dispute resolved successfully');
    navigate('/disputes');
  };

  return (
    <div className="dispute-details-page">
      <div className="page-header">
        <button onClick={() => navigate('/disputes')} className="btn btn-secondary">
          <FaArrowLeft /> Back to Disputes
        </button>
        <div className="page-actions">
          {dispute.status !== 'resolved' && (
            <button className="btn btn-success">
              <FaCheckCircle /> Mark as Resolved
            </button>
          )}
        </div>
      </div>

      {/* Dispute Info */}
      <div className="content-card">
        <h3 className="card-title">Dispute Information</h3>
        <div className="dispute-info-grid">
          <div className="info-item">
            <label>Booking ID</label>
            <span className="booking-id">{dispute.bookingNumber}</span>
          </div>
          <div className="info-item">
            <label>Filed By</label>
            <span>{dispute.filedBy}</span>
          </div>
          <div className="info-item">
            <label>Filed Against</label>
            <span>{dispute.filedAgainst}</span>
          </div>
          <div className="info-item">
            <label>Status</label>
            <span className={`badge badge-${dispute.status === 'resolved' ? 'success' : 'danger'}`}>
              {dispute.status}
            </span>
          </div>
          <div className="info-item">
            <label>Priority</label>
            <span className={`priority-badge priority-${dispute.priority}`}>
              {dispute.priority}
            </span>
          </div>
          <div className="info-item">
            <label>Created Date</label>
            <span>{new Date(dispute.createdAt).toLocaleString()}</span>
          </div>
        </div>

        <div className="dispute-description-section">
          <h4>Reason</h4>
          <p className="dispute-reason-text">{dispute.reason}</p>
          
          <h4>Description</h4>
          <p className="dispute-description-text">{dispute.description}</p>

          {dispute.resolution && (
            <>
              <h4>Resolution</h4>
              <div className="resolution-box">
                <p>{dispute.resolution}</p>
                <span className="resolved-date">
                  Resolved on {new Date(dispute.resolvedAt).toLocaleString()}
                </span>
              </div>
            </>
          )}
        </div>

        {dispute.status !== 'resolved' && (
          <div className="resolution-form">
            <h4>Provide Resolution</h4>
            <textarea
              value={resolution}
              onChange={(e) => setResolution(e.target.value)}
              placeholder="Enter your resolution details..."
              rows="6"
              className="form-control"
            />
            <div className="form-actions">
              <button className="btn btn-success" onClick={handleResolve}>
                <FaCheckCircle /> Submit Resolution
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DisputeDetails;